import { alpha } from '@mui/material/styles';
const disabledStyle = ({ theme })=>({
        color: theme.palette.action.disabled,
        cursor: 'not-allowed',
        textDecorationColor: theme.palette.action.disabled,
        '&:hover': {
            textDecorationColor: alpha(theme.palette.grey['500'], 0.4)
        }
    });
export default function Link() {
    return {
        MuiLink: {
            defaultProps: {
                underline: 'hover'
            },
            styleOverrides: {
                root: (input)=>{
                    if (input.ownerState.disabled) {
                        return disabledStyle(input);
                    }
                    return {
                        cursor: 'pointer'
                    };
                },
                underlineAlways: (input)=>{
                    if (input.ownerState.disabled) {
                        return disabledStyle(input);
                    }
                    return {
                        cursor: 'pointer'
                    };
                },
                underlineHover: (input)=>{
                    if (input.ownerState.disabled) {
                        return disabledStyle(input);
                    }
                    return {
                        cursor: 'pointer'
                    };
                }
            }
        }
    };
}
